<div class="px-14" fxLayoutAlign="space-between center">
  <h3 class="page-title"><ng-content></ng-content></h3>
  <div fxLayout="row" fxLayoutGap="8px">
    <div class="arrow" (click)="arrowHandler(arrows.Previous)">
      <img
        src="assets/images/home/arrow_left.svg"
        alt="arrow"
        [ngClass]="{ arrow_grey: !checkIfArrowDisabled(arrows.Previous) }"
      />
    </div>
    <ng-container>
      <div class="arrow" (click)="arrowHandler(arrows.Next)">
        <img
          src="assets/images/home/arrow_right.svg"
          alt="arrow"
          [ngClass]="{ arrow_grey: !checkIfArrowDisabled(arrows.Next) }"
        />
      </div>
    </ng-container>
  </div>
</div>
